/* KrakenTheMeta — the public site shell: nav (scrolled state, phone menu, active page), signed-in
 * labels without the Firebase SDK, the "Build a deck" CTAs, scroll reveals, and the homepage-style
 * prompt hand-off (localStorage.ktm_pending_deck → sign-in → the dashboard's AI builder).
 */
import "./ui.js";

(function () {
  "use strict";

  var KD = window.KD;
  if (KD.siteReady) return;
  KD.siteReady = true;

  var ABS = "https://krakenthemeta.com";
  var signedIn = false;
  try { signedIn = localStorage.getItem("isSignedIn") === "true"; } catch (e) { /* storage blocked */ }
  KD.signedIn = signedIn;
  KD.page = document.body.getAttribute("data-page") || "";
  KD.buildUrl = function () { return ABS + (signedIn ? "/dashboard" : "/sign-in"); };

  // The dashboard opens the AI builder with this prompt after sign-in (3-day freshness).
  KD.stashPrompt = function (prompt, format) {
    try { localStorage.setItem("ktm_pending_deck", JSON.stringify({ prompt: String(prompt || "").slice(0, 300), format: format || "commander", at: Date.now(), from: KD.page || "site" })); }
    catch (e) { /* storage blocked: they just start fresh */ }
  };

  function rafThrottle(fn) {
    var queued = false;
    return function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () { queued = false; fn(); });
    };
  }

  function nav() {
    var bar = KD.$("[data-nav]");
    if (!bar) return;
    var setScrolled = function () { bar.classList.toggle("is-scrolled", window.scrollY > 16); };
    window.addEventListener("scroll", rafThrottle(setScrolled), { passive: true });
    setScrolled();

    var toggle = KD.$("[data-menu-toggle]"), menu = KD.$("[data-menu]");
    if (toggle && menu) {
      var setMenu = function (open) {
        toggle.setAttribute("aria-expanded", String(open));
        menu.hidden = !open;
        document.body.classList.toggle("menu-open", open);
        var use = toggle.querySelector("use");
        if (use) use.setAttribute("href", open ? "#i-close" : "#i-menu");
      };
      toggle.addEventListener("click", function () { setMenu(toggle.getAttribute("aria-expanded") !== "true"); });
      menu.addEventListener("click", function (e) { if (e.target.closest("a")) setMenu(false); });
      document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !menu.hidden) { setMenu(false); toggle.focus(); } });
    }

    if (signedIn) KD.$$("[data-auth-link]").forEach(function (a) { a.textContent = "Dashboard"; a.href = ABS + "/dashboard"; });
    KD.$$("[data-build-cta]").forEach(function (a) {
      a.href = KD.buildUrl();
      a.addEventListener("click", function () {
        var where = a.closest(".nav, .menu") ? "nav" : a.getAttribute("data-build-cta") || "page";
        KD.ga("site_cta", { page: KD.page, where: where, signed_in: signedIn, transport_type: "beacon" });
      });
    });
    if (KD.page) KD.$$("[data-nav-link]").forEach(function (a) {
      if (a.getAttribute("data-nav-link").split(" ").indexOf(KD.page) !== -1) { a.classList.add("is-active"); a.setAttribute("aria-current", "page"); }
    });
  }

  function reveal() {
    var els = KD.$$("[data-reveal]");
    if (!els.length) return;
    if (KD.reduce || !("IntersectionObserver" in window)) { els.forEach(function (el) { el.classList.add("is-in"); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); } });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  function init() { nav(); reveal(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
